import { useEffect, useState } from 'react';
import { useMarketData } from '../contexts/MarketDataContext';
import { getListedCfdInstrument, isFreshCfdQuote, isTradableCfdQuote } from '../../supabase/functions/_shared/cfdInstruments';
import { getListedCfdReferenceQuote } from '../constants/listedCfdReferenceQuotes';

export function useListedCfdQuote(symbol: string) {
  const { getMarketDataBySymbol } = useMarketData();
  const listing = getListedCfdInstrument(symbol);
  const [now, setNow] = useState(Date.now);

  useEffect(() => {
    if (!listing) return;
    const interval = setInterval(() => setNow(Date.now()), 15_000);
    return () => clearInterval(interval);
  }, [listing]);

  const receivedQuote = listing ? getMarketDataBySymbol(symbol) : null;
  const quoteTime = Math.max(now, Date.now());
  const quoteAvailable = !listing || isTradableCfdQuote(symbol, receivedQuote, quoteTime);
  const quoteIsCurrent = !listing || isFreshCfdQuote(receivedQuote, quoteTime);

  return {
    listing,
    quoteAvailable,
    referenceQuote: listing && !quoteIsCurrent
      ? quoteAvailable && receivedQuote
        ? { price: receivedQuote.price, timestamp: receivedQuote.timestamp }
        : getListedCfdReferenceQuote(symbol, receivedQuote, quoteTime)
      : null,
  };
}
